import backdropLight from '@/assets/auth/backdrop-light.webp';
import backdropDark from '@/assets/auth/backdrop-dark.webp';
import backdropLightMobile from '@/assets/auth/backdrop-light-mobile.webp';
import backdropDarkMobile from '@/assets/auth/backdrop-dark-mobile.webp';

/**
 * The artwork behind the auth screens — the arc, the hairlines and the floating
 * audience cards — as exported from the layout, one per theme and per shape.
 *
 * The phone artwork is not the desktop one cropped: the arc comes in from the
 * bottom-left instead of the top-left, and the floating card sits low. So the
 * anchor changes with it — the desktop art keeps its top-left corner, the phone
 * art keeps its bottom edge, which is where its content lives.
 *
 * <picture> rather than two <img> behind responsive `hidden` classes, because a
 * hidden image is still downloaded.
 */
const backdropClasses =
  'block h-full w-full object-cover object-bottom sm:object-top-left';

export const AuthBackground = () => (
  <div aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden">
    <picture className="block h-full w-full dark:hidden">
      <source media="(min-width: 640px)" srcSet={backdropLight} />
      <img src={backdropLightMobile} alt="" className={backdropClasses} />
    </picture>

    <picture className="hidden h-full w-full dark:block">
      <source media="(min-width: 640px)" srcSet={backdropDark} />
      <img src={backdropDarkMobile} alt="" className={backdropClasses} />
    </picture>
  </div>
);
